import React, { useState, useEffect } from "react";
import { countries } from "countries-list";

import ClickOutside from "react-click-outside";
import cx from "classnames";
import Collapse from "react-collapse";

import arrowDown from "../../assets/images/common/arrow-down-gray.svg";

const CountrySelect = (props) => {
  const [isOpened, setIsOpened] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    if (!props.value) props.onChange("United States", "US");
  }, []);

  const open = (resetSearch = true) => {
    if (resetSearch) {
      setSearchValue("");
    }
    setIsOpened(true);
  };
  const close = () => {
    setSearchValue("");
    setIsOpened(false);
  };

  const handleSelect = (country, countryCode) => {
    setIsOpened(false);
    setSearchValue("");

    props.onChange(country, countryCode);
  };

  return (
    <div className={`country-select ${props.className}`}>
      <ClickOutside onClickOutside={close}>
        {!!props.label && <p className="label">{props.label}</p>}
        <div
          className={cx("select-container", {
            open: isOpened,
            hoverable: props.hoverable,
          })}
        >
          <div
            className="value-container"
            onClick={isOpened ? close : () => open()}
          >
            <input
              value={isOpened ? searchValue : props.value || ""}
              placeholder={props.placeholder}
              onChange={(e) => {
                const value = e.target.value;
                setSearchValue(value);
                props.onChangeInputValue?.(value);
                open(false);
              }}
            />
            <img className="arrow" src={arrowDown} alt="Arrow" />
          </div>
          <Collapse isOpened={isOpened}>
            <div className="options">
              {Object.keys(countries)
                .sort((a, b) =>
                  countries[a].name >= countries[b].name ? 1 : -1,
                )
                .slice(0, Object.keys(countries).length - 1)
                .filter((code) => {
                  if (!searchValue.trim()) {
                    return true;
                  }

                  return countries[code]?.name
                    ?.toLowerCase()
                    .includes(searchValue.toLowerCase());
                })
                .map((code) => (
                  <div
                    key={countries[code].name}
                    className="option"
                    onClick={() => handleSelect(countries[code].name, code)}
                  >
                    {countries[code].name}
                  </div>
                ))}
            </div>
          </Collapse>
        </div>
        {props?.error && <div className="error">{props.error}</div>}
      </ClickOutside>
    </div>
  );
};

export default CountrySelect;
